import React from "react";
import { useNavigate } from "react-router-dom";
import "./Header.css";

interface HeaderProps {
  user?: {
    userid: string;
    email: string;
    name: string;
    companyName?: string;
  };
  onLogout: () => void;
  onLogoClick?: () => void;
  onLogoutClick?: () => void;
}

const Header: React.FC<HeaderProps> = ({
  user,
  onLogout,
  onLogoClick,
  onLogoutClick,
}) => {
  const navigate = useNavigate();

  const handleLogoClick = () => {
    if (onLogoClick) {
      onLogoClick();
    } else {
      navigate("/");
    }
  };

  const handleLogoutClick = () => {
    if (onLogoutClick) {
      onLogoutClick();
    } else {
      // Use default browser popup by triggering beforeunload
      const event = new Event("beforeunload");
      window.dispatchEvent(event);
      onLogout();
    }
  };

  return (
    <header className="app-header">
      <div className="header-content">
        <div className="logo-section">
          <img 
            src="/images/logo.png" 
            alt="コラボフロー for 商奉行 ロゴ" 
            className="app-logo"
            onClick={handleLogoClick}
          />
          <div className="title-user-wrapper">
            <h1
              className="app-title clickable-logo"
              onClick={handleLogoClick}
              role="button"
              tabIndex={0}
              onKeyDown={e => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  handleLogoClick();
                }
              }}
              aria-label="ホームページに戻る"
            >
              コラボフロー for 商奉行
            </h1>
            <div className="user-info">
              <span className="user-id">
                {user?.companyName && (
                  <span className="instance-name">インスタンス名: {user.companyName}</span>
                )}
                ユーザーID: {user?.userid || "admin_user_001"}
              </span>
            </div>
          </div>
        </div>
        <div className="user-section">
          <button
            className="logout-btn"
            onClick={handleLogoutClick}
            title="ログアウト"
          >
            ログアウト
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
